import { useEffect, useMemo, useRef, useState } from "react";
import { IconButton } from "../Icons/IconButton";
import {
  // Button,
  Modal,
} from "react-bootstrap";
// import { XIcon } from "../Icons/XIcon";
import imageCompression from "browser-image-compression";
import {
  BsDownload,
  // BsExclamation,
  BsExclamationTriangleFill,
  // BsEye,
  // BsUpload,
  // BsViewList,
  BsX,
  // BsXCircle,
  // BsZoomIn,
} from "react-icons/bs";
// import LabelViewer from "../../LabelViewer";
import { toast } from "react-toastify";
import { PDFViewer } from "../PDFViewer";
import LoadingSpinner from "../../LoadingSpinner";
// import SimpleTransitionBoth from "../SimpleTransitionBoth";

const getFileExtension = (fileName) => {
  const fileNameParts = fileName.split(".");
  return fileNameParts[fileNameParts.length - 1];
};
const imageFormats = [
  "jpg",
  "jpeg",
  "png",
  "webp",
  "gif",
  "bmp",
  "heif",
  "heic",
  // "tif",//disabled support for tif/tiff as it is not common and browsers do not seem to be able to display it without first converting it to something else. Compression library does not support it either. But there are libraries to work with tiff on npm if wanted in the future.
  // "tiff",
];

//supported by browser-image-compression
const compressibleImageFormats = ["jpg", "jpeg", "png", "webp", "bmp"];
const fileIsCompressible = (fileName) => {
  const fileExt = getFileExtension(fileName);
  if (!fileExt) {
    return false;
  }
  return compressibleImageFormats.includes(fileExt);
};
const documentFormats = ["pdf", "xlsx", "xls"];
// const acceptStringTest =
//   (imageFormats ? "." + imageFormats.join(", .") : "") +
//   ", " +
//   (documentFormats ? "." + documentFormats.join(", .") : "");
// console.log("accept string", acceptStringTest);

const fileIsImageBasedOnExtension = (fileName) => {
  const fileExt = getFileExtension(fileName);
  if (imageFormats.includes(fileExt)) {
    return true;
  }
};
const fileIsImage = (fileType) => {
  return fileType.startsWith("image/");
};
const fileIsPDF = (fileName) => {
  return getFileExtension(fileName) === "pdf";
};
const isPreviewable = (file) => {
  return fileIsImage(file.type) || fileIsPDF(file.name);
};

const fileIsOfSupportedFormat = (file, allowedFiletypes) => {
  const fileExt = getFileExtension(file.name);
  return allowedFiletypes.includes(fileExt);
};

const FilePreviewModal = ({ show, onHide, fileObject }) => {
  //   console.log(fileObject);
  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Previewing {fileObject?.file.name}</Modal.Title>
      </Modal.Header>
      {fileObject && (
        <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
          {show &&
            fileIsImage(fileObject?.type) && ( //have show in here since if images are compressing they won't have a src but then show cannot be true for them as the preview button is disabled
              <img
                src={fileObject?.src}
                style={{
                  objectFit: "contain",
                  maxWidth: "100%",
                  maxHeight: "70dvh",
                  borderRadius: ".5rem",
                }}
              />
            )}
          {fileIsPDF(fileObject?.name) && (
            <PDFViewer id="pdf-preview" pdf={fileObject.file} />
          )}
        </Modal.Body>
      )}
    </Modal>
  );
};
const fileUploadErrors = {
  totalFileSizeLimitExceeded: "totalFileSizeLimitExceeded",
};
export const compressionStatuses = {
  compressed: "Compressed",
  compressing: "Compressing",
  compressionFailed: "Compression Failed",
};

export const convertMBToBytes = (MB) => {
  return MB * 1048576;
};
export const convertBytesToMB = (bytes) => {
  return bytes / 1048576;
};
export const formatBytesForDisplay = (bytes) => {
  const bytesInMB = convertBytesToMB(bytes);
  if (bytesInMB % 1 != 0) {
    //if decimal
    // console.log((bytesInMB + "").split("."));
    const bytesInMBWhole = (bytesInMB + "").split(".")[0];
    const bytesInMBFraction = (bytesInMB + "").split(".")[1];
    return bytesInMBWhole + "." + bytesInMBFraction.slice(0, 2);
  } else {
    return bytesInMB;
  }
  // return (convertBytesToMB(bytes) + "").slice(0, 5);
};

export const FileUploadV2 = ({
  allowedFiletypes = [...imageFormats, ...documentFormats], //without periods
  allowDuplicates = false, // Only checks by name, just in case you want to allow the instance they have files with the same name from different folders they want to upload. Maybe further implement by auto adding a number to duplicate file names like windows does. i.e. fileToUpload.png, fileToUpload(1).png, fileToUpload(2).png
  sizeLimitInMB = 10,
  //sizeLimitPerItemInMB //implement this, with undefined/null being no limit.
  compressImages = true, // true if we should try to compress images based on compression options or false for never compress.
  imageCompressionSizeThreshold = 2, // If an image is greater than this, we will compress it and let the client know.
  compressionTargetSizeInMB = imageCompressionSizeThreshold, //default compression target is equal to the threshold. i.e. if the image is bigger than 1mb, try to make it 1mb
  itemLimit = 5,
  handleChangeFiles,
}) => {
  const acceptString = "." + allowedFiletypes.join(", .");
  const [fileObjectsToUpload, setFileObjectsToUpload] = useState([]);
  const filesAreCompressing = useMemo(() => {
    return (
      fileObjectsToUpload.filter(
        (fileObject) =>
          fileObject.compressionStatus === compressionStatuses.compressing
      ).length > 0
    );
  }, [fileObjectsToUpload]);
  // console.log("files are compressing", filesAreCompressing);
  const totalFileSize = useMemo(() => {
    return fileObjectsToUpload
      .filter(
        (file) => file.compressionStatus !== compressionStatuses.compressing
      )
      .reduce((sum, currentFileObject) => {
        return (sum += currentFileObject.file.size);
      }, 0);
  }, [fileObjectsToUpload]);
  // console.log("total File Size Memo", totalFileSize);
  const [isDraggedOver, setIsDraggedOver] = useState(false);

  const dropZoneRef = useRef();
  const handleDragEnter = (e) => {
    // console.log("entered");
    setIsDraggedOver(true);
  };
  const handleDragLeave = (e) => {
    // console.log("drag leave");
    // console.log("left", e);
    const dragLeaveNotDueToHoveringOverChild =
      e.target === dropZoneRef.current &&
      !dropZoneRef.current?.contains(e.relatedTarget);
    const dragLeftDropzoneCalledFromChild =
      dropZoneRef.current?.contains(e.target) &&
      !dropZoneRef.current?.contains(e.relatedTarget);
    if (dragLeaveNotDueToHoveringOverChild || dragLeftDropzoneCalledFromChild) {
      setIsDraggedOver(false);
    }
  };
  const handleDragEnd = (e) => {
    // I didn't see this event called in either chrome, edge, firefox for anything.
    // Even so all cases tested seem to work fine even with this commented out.
    // Dropping the files whether invalid or valid handle removing the dragged over state.
    // Cancellation (by leaving, esc key, or right mouse click) seem to call dragLeave instead and are handled through that.
    // Leaving it in here just in case.
    // console.log("hi drag end");
    setIsDraggedOver(false);
  };
  const handleDragOver = (e) => {
    //need to prevent default for the dragover event or else handleDrop won't be run?
    //https://stackoverflow.com/a/32084240
    e.preventDefault();
  };

  //const MAX_FILE_SIZE = 52428800; // 50MB = 52428800 bytes OR 50,000,000 bytes (depends who you ask) (The File object's size property is in bytes)
  const MAX_UPLOAD_SIZE = convertMBToBytes(sizeLimitInMB);

  const stageFilesForUpload = async (filesToStage) => {
    // console.log("files to stage beginning", filesToStage);
    //To prevent the case where user renamed a folder to a valid file type (e.g. renaming a Documents folder to Documents.png). The backend would error out anyway but seemed weird they could do that.
    //If a legitimate file was of size 0 it probably wouldn't be useful anyway.
    const invalidFilesBasedOnSizeBeing0 = filesToStage
      .filter((file) => file.size === 0)
      .map((file) => file.name);
    if (invalidFilesBasedOnSizeBeing0.length > 0) {
      toast.error(
        "Invalid File(s):\n" + invalidFilesBasedOnSizeBeing0.join(", \n")
      );
      return;
    }
    // console.log(filesToStage);
    if (
      filesToStage.filter((file) => {
        return !fileIsOfSupportedFormat(file, allowedFiletypes);
      }).length > 0
    ) {
      toast.error(
        `Unsupported file type. Please upload one of the following: ${allowedFiletypes.join(
          ", "
        )}.`
      );
      return;
    }
    if (!allowDuplicates) {
      const duplicateFiles = filesToStage.filter((selectedFile) => {
        return fileObjectsToUpload
          .map((fileObject) => fileObject.file.name)
          .includes(selectedFile.name);
      });
      if (duplicateFiles.length > 0) {
        toast.error(
          `You have already uploaded:\n${duplicateFiles
            .map((file, index) => index + 1 + ". " + file.name)
            .join(",\n")}`
        );
        return;
      }
    }
    if (filesToStage.length + fileObjectsToUpload.length > itemLimit) {
      toast.error(`You may only upload up to ${itemLimit} file(s).`);
      return;
    }

    if (!compressImages) {
      let fileSizeWouldBe = 0;
      for (const fileObject of fileObjectsToUpload) {
        fileSizeWouldBe += fileObject.file.size;
      }
      for (const file of filesToStage) {
        fileSizeWouldBe += file.size;
      }
      if (fileSizeWouldBe > MAX_UPLOAD_SIZE) {
        toast.error(
          "Total File Size should not exceed " +
            formatBytesForDisplay(MAX_UPLOAD_SIZE) +
            "MB"
          // +
          // "\nYou're File Size is: " +
          // formatBytesForDisplay(fileSizeWouldBe) + "MB"
        );
        return;
      }
    }

    const fileObjects = filesToStage.map((file) => {
      const shouldCompress =
        compressImages &&
        fileIsImage(file.type) &&
        fileIsCompressible(file.name) &&
        convertBytesToMB(file.size) > imageCompressionSizeThreshold;
      const originalFileName = file.name;
      return {
        name: file.name,
        originalSize: file.size,
        size: file.size,
        type: file.type,
        file: shouldCompress
          ? imageCompression(file, {
              maxSizeMB: compressionTargetSizeInMB,
            })
              .then((res, err) => {
                // console.log("res", res);
                //Testing other failures
                // const randomFail = Math.random() > 0.5;
                // if (randomFail) {
                // throw new Error("Random");
                // }
                //total file size exceeded error handling
                // if (false) {//we would have to calculate the total file size of the already compressed items + the compressed size of the new item, but what about other files that are compressing, already? Well I guess they would finish later and fail if the limit is exceeded afterwards and handle itself. But for now leaving it up to the user to see that it is over the limit and adjust on their own.
                //   // return `${res.name} would cause total file size to exceed ${MAX_UPLOAD_SIZE}`;
                //   const fileUploadError = new Error(
                //     `${
                //       res.name
                //     } would cause total file size to exceed ${formatBytesForDisplay(
                //       MAX_UPLOAD_SIZE
                //     )}MB`
                //   );
                //   fileUploadError.fileName = res.name;
                //   fileUploadError.type =
                //     fileUploadErrors.totalFileSizeLimitExceeded;
                //   throw fileUploadError;
                // }
                // console.log("err", res);

                setFileObjectsToUpload((prevFileObjectsToUpload) => {
                  return prevFileObjectsToUpload.map((fileObject) => {
                    // console.log("about to set to compressed");
                    if (res.name === fileObject.name) {
                      return {
                        ...fileObject,
                        file: res,
                        size: res.size,
                        compressionStatus: compressionStatuses.compressed,
                        src: isPreviewable(file)
                          ? URL.createObjectURL(res)
                          : null,
                      };
                    } else return fileObject;
                  });
                });
              })
              .catch((ex) => {
                // console.log(ex);
                //Not currently implemented as of 2026/02/04:
                if (ex.type === fileUploadErrors.totalFileSizeLimitExceeded) {
                  // console.log("Total file size limit exceeded exception", ex);
                  toast.error(ex.message);
                  setFileObjectsToUpload((prevFileObjectsToUpload) => {
                    return prevFileObjectsToUpload.filter((fileObject) => {
                      return ex.fileName !== fileObject.name;
                    });
                  });
                } else {
                  //If we get an error, mark it as compression failed and revert back to original image
                  setFileObjectsToUpload((prevFileObjectsToUpload) => {
                    return prevFileObjectsToUpload.map((fileObject) => {
                      // console.log(
                      //   "compression failure reverted back to original"
                      // );
                      // console.log("original file name", originalFileName);
                      //I wasn't sure if the library returns the file name in the errors it throws so I used this variable. Probably don't even need to set a variable but could just use file.name
                      if (originalFileName === fileObject.name) {
                        return {
                          ...fileObject,
                          file: file,
                          compressionStatus:
                            compressionStatuses.compressionFailed,
                          src: isPreviewable(file)
                            ? URL.createObjectURL(file)
                            : null,
                        };
                      } else return fileObject;
                    });
                  });
                }
              })
          : file, //did not need to compress
        compressionStatus: shouldCompress
          ? compressionStatuses.compressing
          : "",
        src: isPreviewable(file)
          ? shouldCompress
            ? null
            : URL.createObjectURL(file)
          : null,
        isPreviewable: isPreviewable(file),
      };
    });

    // console.log("filesToStage", filesToStage);
    // console.log("file objects", fileObjects);
    // console.log("event files", event.target.files);
    // console.log("processed files", files);
    //set files to state
    setFileObjectsToUpload((prevFileObjectsToUpload) => {
      const newFileObjectsToUpload = [
        ...prevFileObjectsToUpload,
        ...fileObjects,
      ];
      return newFileObjectsToUpload;
    });
    // console.log([...fileObjectsToUpload, ...fileObjects]);
  };
  // console.log("file objects to upload", fileObjectsToUpload);
  useEffect(() => {
    // console.log("fileObjectsToUpload Changed, set in parent");
    handleChangeFiles(fileObjectsToUpload);
  }, [fileObjectsToUpload]);

  const handleChooseFiles = (event) => {
    const selectedFiles = [...event.target.files];
    stageFilesForUpload(selectedFiles);
  };
  const handleDropFiles = (e) => {
    e.preventDefault();
    setIsDraggedOver(false);
    // isDraggingInWindowRef.current = false;
    const droppedFiles = [...e.dataTransfer.files];
    // console.log(e.dataTransfer.files);
    // console.log(e.dataTransfer.types);
    //
    //Adding validation to prevent user from dropping text or images from the browser
    //First making sure they did drop a file and not just text but
    //can't check just to see if it includes Files because files/images dropped from the browser to the browser will include that type, but they will also include other things such as text/uri-list we can use to prevent it.
    if (
      !e.dataTransfer.types.includes("Files") ||
      e.dataTransfer.types.includes("text/uri-list") //don't allow images drag and dropped from a website
    ) {
      toast.error("Please drop a valid file.");
      return;
    }
    stageFilesForUpload(droppedFiles);
  };

  //this will drop a file from the files to be uploaded
  const cancelFile = (fileIndex) => {
    let newFiles = [...fileObjectsToUpload];
    newFiles.splice(fileIndex, 1);
    setFileObjectsToUpload(newFiles);
  };

  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [fileToPreviewIndex, setFileToPreviewIndex] = useState();

  const handleClickPreviewFile = (fileIndex) => {
    setShowPreviewModal(true);
    setFileToPreviewIndex(fileIndex);
  };
  const handleClosePreviewModal = () => {
    setShowPreviewModal(false);
  };
  //   console.log(fileObjectsToUpload);

  //Attempt to to fix buggy behavior onDragLeave of dropzone due to children elements but was able to fix using checks on e.target and e.relatedtarget in the dragLeave event.
  //I believe this was working also as well, with the 1 difference that this would highlight the dropzone as soon as the user drags inside the window instead of over the dropzone, which might be preferable. But added a drop here text on dropzone so that it is even more obvious either way.
  //   const isDraggingInWindowRef = useRef(false);
  //   const enterWindow = () => {
  //     if (!isDraggingInWindowRef.current) {
  //       console.log("entered window");
  //       setIsDraggedOver(true);
  //       isDraggingInWindowRef.current = true;
  //     }
  //   };
  //   const dragEnd = () => {
  //     console.log("ended");
  //     setIsDraggedOver(false);
  //     isDraggingInWindowRef.current = false;
  //   };
  //   const dragLeave = (e) => {
  //     console.log(e);
  //     console.log("left");
  //     setIsDraggedOver(false);
  //     isDraggingInWindowRef.current = false;
  //   };
  //   const dragOver = (e) => {
  //     e.preventDefault();
  //   };
  //   const drop = (e) => {
  //     e.preventDefault();
  //   };
  //   const escapeKey = (e) => {
  //     console.log(e.key);
  //     if (e.key === "Escape") {
  //       if (isDraggingInWindowRef.current) {
  //         setIsDraggedOver(false);
  //         isDraggingInWindowRef.current = false;
  //       }
  //     }
  //   };
  //   useEffect(() => {
  //     window.addEventListener("dragenter", enterWindow);
  //     window.addEventListener("dragend", dragEnd);
  //     window.addEventListener("dragover", dragOver);
  //     window.addEventListener("drop", drop);
  //     window.addEventListener("keydown", escapeKey);
  //     return () => {
  //       window.removeEventListener("dragenter", enterWindow);
  //       window.removeEventListener("dragend", dragEnd);
  //       window.removeEventListener("dragover", dragOver);
  //       window.removeEventListener("drop", drop);
  //       window.removeEventListener("keydown", escapeKey);
  //     };
  //   }, []);

  //   console.log("re-rendered");

  return (
    <>
      <FilePreviewModal
        show={showPreviewModal}
        onHide={handleClosePreviewModal}
        fileObject={fileObjectsToUpload[fileToPreviewIndex]}
      />
      <div className="file-upload-container">
        <div className="file-upload-header">
          <input
            type="file"
            name="files"
            id="file-uploader"
            multiple
            //   accept="image/*,.pdf,.docx,.doc,.csv,.xls,application/vnd.ms-excel,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            // accept="image/*, .pdf, .xlsx, .xls"
            accept={acceptString}
            onChange={handleChooseFiles}
            value="" //allows same file twice. If this is not used, our logic won't run if they try to add the same file twice in a row. Using this so we can keep displaying the error message if they keep trying to upload an incorrect filetype, otherwise it would only run on the first attempt. Handling not accepting multiple of the same file in our own logic.
            hidden
          />
          {fileObjectsToUpload.length > 0 ? (
            <label
              htmlFor="file-uploader"
              className="btn btn-primary"
              role="button"
            >
              Choose Files
            </label>
          ) : (
            <label></label>
          )}

          {/* <div
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h1>move this to its own component</h1>
        <h2>Add validation</h2>
      </div> */}
          <div className="file-upload-info">
            <div className="file-upload-info-size">
              <span
                className={totalFileSize > MAX_UPLOAD_SIZE ? "text-danger" : ""}
              >
                {fileObjectsToUpload.some((fileObject) => {
                  return (
                    fileObject.compressionStatus ===
                    compressionStatuses.compressing
                  );
                }) ? (
                  <LoadingSpinner />
                ) : (
                  formatBytesForDisplay(totalFileSize) + "MB"
                )}{" "}
                / {formatBytesForDisplay(MAX_UPLOAD_SIZE)}MB
                {totalFileSize > MAX_UPLOAD_SIZE ? (
                  <BsExclamationTriangleFill
                    size={16}
                    style={{ margin: "-5px 0px 0px 5px" }}
                  />
                ) : (
                  ""
                )}
              </span>
            </div>
            <div className="file-upload-info-count">
              {fileObjectsToUpload.length} / {itemLimit}{" "}
              {itemLimit === 1 ? "item" : "items"}
            </div>
          </div>
        </div>
        <div
          ref={dropZoneRef}
          //   className="file-upload-contents"
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragEnd={handleDragEnd}
          onDragOver={handleDragOver}
          onDrop={handleDropFiles}
          style={{ position: "relative" }}
        >
          <div
            style={{
              position: "absolute",
              //   pointerEvents: "auto",
              pointerEvents: fileObjectsToUpload.length > 0 ? "none" : "auto",
              userSelect: fileObjectsToUpload.length > 0 ? "" : "none",
              inset: 0,
              boxShadow: isDraggedOver
                ? "0px 0px 0px 2px rgb(50,200,230) inset"
                : "",
              display: "grid",
              placeContent: "center",
              backgroundColor: isDraggedOver ? "rgb(0,0,0,.3)" : "",
              opacity:
                fileObjectsToUpload.length === 0 || isDraggedOver ? 1 : 0,
            }}
          >
            <div
              style={{
                textAlign: "center",
                color: isDraggedOver ? "white" : "",
                transition: isDraggedOver ? "transform .5s" : "",
                transform: isDraggedOver ? "scale(1.2)" : "scale(1)",
                fontWeight: isDraggedOver ? 600 : "",
                fontSize: "1.1rem",
              }}
            >
              {isDraggedOver ? (
                <>
                  <BsDownload size={30} />
                  <br />
                  Drop To Upload
                </>
              ) : (
                <>
                  <label
                    htmlFor="file-uploader"
                    className="btn btn-primary mb-2"
                    role="button"
                  >
                    Choose Files
                  </label>{" "}
                  <br />
                  <BsDownload size={30} />
                  <br />
                  <div className="mt-2">or Drop Here</div>
                </>
              )}
            </div>
          </div>
          <div className="file-upload-contents">
            {fileObjectsToUpload.map((fileObject, index) => (
              <div
                key={fileObject.file.name + "-" + index}
                className="file-upload-item"
                style={{ minWidth: "100%", width: "fit-content" }}
                onDragLeave={(e) => {
                  // e.stopPropagation(); //doing this to prevent our onDragLeave event firing from hovering over these children items. Alternatively you could probably check for if the item inside the dropzone's dragLeave event is a descendant of it and ignore the event.
                }}
              >
                <div style={{ padding: "4px", display: "flex" }}>
                  <IconButton
                    onClick={() => {
                      cancelFile(index);
                    }}
                    buttonClassAppend="text-note"
                    icon={<BsX size={20} />}
                  >
                    {/*Black to match material-table/core */}
                    {/* <DeleteOutlineIcon style={{ color: "black" }} /> */}x
                  </IconButton>
                </div>
                <div className="pr-3">{fileObject.name} </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: 1,
                    justifyContent: "end",
                  }}
                >
                  {fileObject.compressionStatus &&
                    fileObject.compressionStatus !==
                      compressionStatuses.compressionFailed && (
                      <div
                        className="mr-2"
                        style={{
                          borderRadius: "10000px",
                          backgroundColor: "#8f8f8f",
                          color: "white",
                          fontWeight: "600",
                          fontSize: ".8rem",
                          padding: ".1rem .45rem",
                          lineHeight: "1.3rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {fileObject.compressionStatus}{" "}
                        {fileObject.compressionStatus ===
                          compressionStatuses.compressing && (
                          <LoadingSpinner className="ml-1" />
                        )}
                      </div>
                    )}
                  <div
                    className="mr-2"
                    style={{
                      borderRadius: "10000px",
                      backgroundColor: "#8f8f8f",
                      color: "white",
                      fontWeight: "600",
                      fontSize: ".8rem",
                      padding: ".1rem .45rem",
                      lineHeight: "1.3rem",
                    }}
                  >
                    {formatBytesForDisplay(fileObject.size)}MB
                  </div>
                </div>
                {fileObject.isPreviewable && (
                  <div
                    style={{ marginLeft: "auto" }}
                    className={`text-note font-600 mr-3 clickable${
                      fileObject.compressionStatus ===
                      compressionStatuses.compressing
                        ? " disabled-gray"
                        : ""
                    }`}
                    role="button"
                    onClick={() => {
                      if (
                        fileObject.compressionStatus ===
                        compressionStatuses.compressing
                      ) {
                        toast.warn("File is currently being compressed.");
                        return;
                      }
                      handleClickPreviewFile(index);
                    }}
                  >
                    Preview
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
